import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import {ErrorList, TextInputError, Title} from './CheckoutErrorModal.style';
import {Button2} from '../../styles/components/button.style';
import {defaultStyles} from '../Modal/modal.config';
import {Wrapper} from '../Modal/modal.style';
import {FormattedMessage} from 'react-intl';

class CheckoutErrorModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true
    };
    this.initModal = this.initModal.bind(this);
  }

  initModal() {
    return document.body;
  }

  render() {
    const {errors, isDelivery, handleCloseModal} = this.props;
    const renderAsyncErrors =
      errors &&
      Object.entries(errors).map(error => {
        if (
          !isDelivery &&
          (error[0] === 'addressLine1' || error[0] === 'city' || error[0] === 'postcode')
        ) {
          return;
        }
        return (
          <TextInputError key={error}>
            <FormattedMessage id={error[1] === 'required' ? `form.${error[0]}.required` : error[1]} />
          </TextInputError>
        );
      });

    return (
      <div>
        <Modal
          isOpen={this.state.showModal}
          style={defaultStyles}
          onRequestClose={handleCloseModal}
          parentSelector={this.initModal}
          contentLabel="Modal"
          shouldCloseOnOverlayClick={false}
        >
          <Wrapper>
            <Title><FormattedMessage id="checkoutErrorModal.title" /></Title>
            <ErrorList>
              {renderAsyncErrors}
            </ErrorList>
            <Button2 onClick={handleCloseModal}><FormattedMessage id="checkoutErrorModal.close" /></Button2>
          </Wrapper>
        </Modal>
      </div>
    );
  }
}

CheckoutErrorModal.propTypes = {
  errors: PropTypes.object.isRequired,
  isDelivery: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired
};

export default CheckoutErrorModal;




// WEBPACK FOOTER //
// ./components/CheckoutErrorModal/CheckoutErrorModal.js